import { endpoints } from "../endpoints";
import type {
  AssetContainerType,
  ExternalLinkAssociationKey,
} from "./assetContainer.types";

export function getAssetListEndpoint(
  containerType: AssetContainerType,
  tenantId: string,
  containerId: string
): string {
  switch (containerType) {
    case "product":
      return `/v2/tenants/${tenantId}/pim/products/${containerId}/assets`;
    case "customer":
      return endpoints.v2_tenants_id_customers_id_assets(tenantId, containerId);
    case "supplier":
      return endpoints.v2_tenants_id_suppliers_id_assets(tenantId, containerId);
    case "distributor":
      return endpoints.v2_tenants_id_distributors_id_assets(
        tenantId,
        containerId
      );
  }
}

export function getAssetAssociateEndpoint(
  containerType: AssetContainerType,
  tenantId: string,
  containerId: string
): string {
  switch (containerType) {
    case "product":
      return endpoints.v2_tenants_tenant_id_pim_products_product_id_assets_associate(
        tenantId,
        containerId
      );
    case "customer":
      return endpoints.v2_tenants_id_customers_id_assets_associate(
        tenantId,
        containerId
      );
    case "supplier":
      return endpoints.v2_tenants_id_suppliers_id_assets_associate(
        tenantId,
        containerId
      );
    case "distributor":
      return endpoints.v2_tenants_id_distributors_id_assets_associate(
        tenantId,
        containerId
      );
  }
}

export function getExternalLinksListEndpoint(
  containerType: AssetContainerType,
  tenantId: string,
  containerId: string
): string {
  switch (containerType) {
    case "product":
      return `/v2/tenants/${tenantId}/pim/products/${containerId}/external-links`;
    case "customer":
      return endpoints.v2_tenants_id_customers_id_external_links(
        tenantId,
        containerId
      );
    case "supplier":
      return endpoints.v2_tenants_id_suppliers_id_external_links(
        tenantId,
        containerId
      );
    case "distributor":
      return endpoints.v2_tenants_id_distributors_id_external_links(
        tenantId,
        containerId
      );
  }
}

export function getExternalLinkAssociationKey(
  containerType: AssetContainerType
): ExternalLinkAssociationKey {
  switch (containerType) {
    case "product":
      return "product_ids";
    case "customer":
      return "customer_ids";
    case "supplier":
      return "supplier_ids";
    case "distributor":
      return "distributor_ids";
  }
}
